var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSerialNumberIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0.5H0V16.5H2.66667V0.5Z",
    fill: "#00609B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3737 0.5H6.70703V16.5H9.3737V0.5Z",
    fill: "#00609B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 0.5H10.7476V16.5H13.4142V0.5Z",
    fill: "#00609B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 0.5H20.0403V16.5H23.9999V0.5Z",
    fill: "#00609B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33321 0.5H4.04028V16.5H5.33321V0.5Z",
    fill: "#00609B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H14.707V16.5H16V0.5Z",
    fill: "#00609B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 0.5H17.3738V16.5H18.6667V0.5Z",
    fill: "#00609B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerialNumberIcon);
export default __webpack_public_path__ + "static/media/SerialNumberIcon.65a676866c893c45a5428f3fa198a293.svg";
export { ForwardRef as ReactComponent };